import { IGlobalState } from '../../../Root/store/appReducer'
import { GoalId } from '../../../services/api.types'

const getGoalProperty = (property: string) => (state: IGlobalState, goalId: GoalId) => {
  const goal = state.activity.goals[goalId]
  // @ts-ignore
  return goal && goal[property] !== undefined ? goal[property] : null
}

export const getUserProgress = getGoalProperty('userProgress')
export const getActivityFilter = getGoalProperty('activityFilter')
export const getActivityView = getGoalProperty('activityView')
export const getGroupView = getGoalProperty('groupView')
export const getGroupSum = getGoalProperty('groupSum')
export const getUserIsInActivityList = getGoalProperty('userIsInActivityList')
export const getActivityProgress = getGoalProperty('activityProgress')
export const getDivisionActivityProgress = getGoalProperty('divisionActivityProgress')
export const getCountryActivityProgress = getGoalProperty('countryActivityProgress')
export const getActivityPeriodPercentage = getGoalProperty('activityPeriodPercentage')
export const getActivityProgressLoading = getGoalProperty('activityProgressLoading')

export const getUserGoals = (state: IGlobalState) => state.activity.userGoals
export const getGoalsDtoLoading = (state: IGlobalState) => state.activity.goalsDtoLoading

export const getUserGoal = (state: IGlobalState, goalId: GoalId) => {
  return state.activity.userGoals.find(({ id }) => id === goalId)
}

export const getActivityListTab = (state: IGlobalState) => state.activity.activityListTab
export const getActivityListTabSetAt = (state: IGlobalState) => state.activity.activityListTabSetAt
export const getActivityListTypeTab = (state: IGlobalState) => state.activity.activityListTypeTab

export const getUserDto = (state: IGlobalState) => state.auth.userDto
